import produce from 'immer'
import { cloneDeep } from 'lodash'
import { getType } from 'typesafe-actions'
import * as actions from './actions'
import { State, Action } from './types'
import { initEvent, initMeta } from 'Store/common/common.reducer'
import parseErrorMessage from 'helpers/parseErrorMessage'
import { convertMetaData } from 'Store/common/common.function'

const initialState: State = {
  actionEvent: cloneDeep(initEvent),
  userList: {
    data: [],
    meta: cloneDeep(initMeta),
    event: cloneDeep(initEvent),
  },
  roleList: {
    data: [],
    event: cloneDeep(initEvent),
  },
  userDetail: {
    data: undefined,
    event: cloneDeep(initEvent),
  },
}

export default function(state: State = initialState, action: Action) {
  return produce(state, draft => {
    let response
    switch (action.type) {
      case getType(actions.getStaffListAction.request):
        draft.userList.event = cloneDeep(initEvent)
        draft.userList.event.IsLoading = true
        draft.userList.data = []
        draft.userList.meta = cloneDeep(initMeta)
        return draft
      case getType(actions.getStaffListAction.success):
        response = action.payload
        draft.userList.event.IsLoading = false
        draft.userList.event.SubmitSuccess = true
        draft.userList.data = response.data
        if (response.meta) {
          draft.userList.meta = convertMetaData(response.meta)
        }
        return draft
      case getType(actions.getStaffListAction.failure):
        draft.userList.event.IsLoading = false
        draft.userList.event.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.getMerchantRoleAction.request):
        draft.roleList.event = cloneDeep(initEvent)
        draft.roleList.event.IsLoading = true
        draft.roleList.data = []
        return draft
      case getType(actions.getMerchantRoleAction.success):
        response = action.payload
        draft.roleList.event.IsLoading = false
        draft.roleList.event.SubmitSuccess = true
        draft.roleList.data = response.data
        return draft
      case getType(actions.getMerchantRoleAction.failure):
        draft.roleList.event.IsLoading = false
        draft.roleList.event.SubmitError = parseErrorMessage(action.payload)
        return draft

      case getType(actions.createAction.request):
      case getType(actions.updateAction.request):
      case getType(actions.deleteAction.request):
      case getType(actions.resetPasswordAction.request):
      case getType(actions.updateStatusAction.request):
        draft.actionEvent = cloneDeep(initEvent)
        draft.actionEvent.IsLoading = true
        return draft
      case getType(actions.createAction.success):
      case getType(actions.updateAction.success):
      case getType(actions.deleteAction.success):
      case getType(actions.resetPasswordAction.success):
      case getType(actions.updateStatusAction.success):
        response = action.payload
        if (response?.status?.code === 200) {
          draft.actionEvent.IsLoading = false
          draft.actionEvent.SubmitError = undefined
          draft.actionEvent.SubmitSuccess = true
          draft.actionEvent.MessageSuccess = 'ทำรายการสำเร็จ'
        } else {
          draft.actionEvent.IsLoading = false
          draft.actionEvent.SubmitError = response?.message
        }
        return draft
      case getType(actions.createAction.failure):
      case getType(actions.updateAction.failure):
      case getType(actions.deleteAction.failure):
      case getType(actions.resetPasswordAction.failure):
      case getType(actions.updateStatusAction.failure):
        draft.actionEvent.IsLoading = false
        draft.actionEvent.SubmitError = action.payload.message
        return draft
      case getType(actions.getDetailAction.request):
        draft.userDetail.event = cloneDeep(initEvent)
        draft.userDetail.event.IsLoading = true
        draft.userDetail.data = undefined
        return draft
      case getType(actions.getDetailAction.success):
        response = action.payload
        draft.userDetail.event.IsLoading = false
        draft.userDetail.event.SubmitSuccess = true
        draft.userDetail.data = response.data
        return draft
      case getType(actions.getDetailAction.failure):
        draft.userDetail.event.IsLoading = false
        draft.userDetail.event.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.clearEventAction):
        draft.userList.event = cloneDeep(initEvent)
        draft.roleList.event = cloneDeep(initEvent)
        draft.actionEvent = cloneDeep(initEvent)
        return draft
      default:
        return state
    }
  })
}
